<xm-modal-close xmEscKey (escKeyPressed)="close('close')" (onClose)="close('close')"></xm-modal-close>
<section>
    <div class="content">
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="auto" ></xm-media-image>
        </div>
        <h2>{{ pageData.header }}</h2>
        <div class="subheader">
            {{ featureDescription }}
        </div>
        <div class="flex-container">
            <div class="feature-content">
                <p class="feature-header">
                    {{ pageData.featureHeader }}
                </p>
                <div class="feature-list" *ngFor="let feature of features">
                    <xm-media-image [imageOptions]="feature.imageOption" size="height" class="icons"></xm-media-image>
                    <p class="feature-description">{{ feature.description }}</p>
                </div>
            </div>
        </div>
        <div class="buttons">
            <button class="xm-btn-primary-light" (click)="close('close')">{{ pageData.buttonText }}</button>
        </div>
    </div>
</section>
